"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./ProgressBar.scss");

var _excluded = ["value", "min", "max", "skin", "size", "isIndeterminate", "variant", "className", "showPercentage"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** The current value of the progress*/
  value: _propTypes.number,
  min: _propTypes.number,
  max: _propTypes.number,

  /** Changes the height of the bar. */
  size: (0, _propTypes.oneOf)(['small', 'medium']),

  /** Pick your preferred skin */
  skin: (0, _propTypes.oneOf)(['red', 'dark', 'neutral', 'light']),

  /** Show or hide percentage */
  showPercentage: _propTypes.bool,

  /** Use when you do not know how long the operation will take. */
  isIndeterminate: _propTypes.bool,

  /** Choose between rounded or square ends on the lines. */
  variant: (0, _propTypes.oneOf)(['rounded', 'square']),

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  variant: 'rounded',
  size: 'medium',
  skin: 'red',
  value: 0,
  min: 0,
  max: 100,
  showPercentage: false
};
/**
 * A progress bar displays status of a determinate or indeterminate process.
 * @visibleName Progress Bar
 * */

var ProgressBar = function ProgressBar(_ref) {
  var value = _ref.value,
      min = _ref.min,
      max = _ref.max,
      skin = _ref.skin,
      size = _ref.size,
      isIndeterminate = _ref.isIndeterminate,
      variant = _ref.variant,
      className = _ref.className,
      showPercentage = _ref.showPercentage,
      rest = _objectWithoutProperties(_ref, _excluded);

  var getPercentage = function getPercentage() {
    return Math.round((value - min) / (max - min) * 100 * 10) / 10;
  };

  var componentClassNames = (0, _classnames.default)('rds-progress-bar', {
    'rds-progress-bar--is-indeterminate': isIndeterminate,
    'rds-progress-bar--has-percentage': showPercentage,
    'rds-progress-bar--size-small': size === 'small',
    'rds-progress-bar--size-medium': size === 'medium',
    'rds-progress-bar--skin-red': skin === 'red',
    'rds-progress-bar--skin-dark': skin === 'dark',
    'rds-progress-bar--skin-neutral': skin === 'neutral',
    'rds-progress-bar--skin-light': skin === 'light',
    'rds-progress-bar--round-caps': variant === 'rounded'
  }, className);

  if (isIndeterminate) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: componentClassNames
    }, /*#__PURE__*/_react.default.createElement("div", _extends({
      className: 'rds-progress-bar__track'
    }, rest), /*#__PURE__*/_react.default.createElement("div", {
      role: "progressbar",
      className: "rds-progress-bar__progress"
    })));
  } else {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: componentClassNames
    }, /*#__PURE__*/_react.default.createElement("div", _extends({
      className: 'rds-progress-bar__track'
    }, rest), /*#__PURE__*/_react.default.createElement("div", {
      role: "progressbar",
      className: 'rds-progress-bar__progress',
      "aria-valuenow": "".concat(getPercentage(), "%"),
      "aria-valuemin": min,
      "aria-valuemax": max,
      style: {
        width: "".concat(getPercentage(), "%")
      }
    })), showPercentage && /*#__PURE__*/_react.default.createElement("div", {
      className: "rds-progress-bar__percentage"
    }, "".concat(getPercentage(), "%")));
  }
};

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;
var _default = ProgressBar;
exports.default = _default;